import styled from '@emotion/styled';
import { Grid } from '@mui/material';
import { colors } from 'theme/colors';

export const StyledContainerAccountTypes = styled(Grid)`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-bottom: 40px;
`;

export const LoginOption = styled(Grid)`
  display: grid;
  padding: 40px;
  gap: 60px;
  border-radius: 4px;
  background: ${colors.white};
  border: 1px solid #cad3f5;
  box-shadow: 0px 6px 10px 0px #c2ccf333;
  box-shadow: 0px 4px 8px 0px #c2ccf333;
  box-shadow: 0px 2px 6px 0px #c2ccf34d;
  box-shadow: 0px 2px 4px 0px #c2ccf359;
`;

export const LoginOptionItem = styled(Grid)`
  display: grid;
  gap: 10px;
`;
